import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Nav } from "./Nav";
import { Footer } from "./Footer";

export const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  // Handle hash + top scrolling on route change
  useEffect(() => {
    const scrollToHash = () => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 80;
          if (window.__lenis) window.__lenis.scrollTo(top);
          else window.scrollTo({ top });
          return;
        }
      }
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    };
    const t = setTimeout(scrollToHash, 60);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <div className="grain relative min-h-screen bg-obsidian">
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
